// @ts-nocheck

import * as BasketStyles from './basket';
import * as BurgerStyles from './burger-menu';
import * as Cgu from './cgu';
import * as CommonStyles from './common';
import * as Countdown from './countdown';
import * as DesktopNavigationBarStyles from './desktop-navigation-bar';
import * as FilterStyles from './filters';
import * as HighlightsStyles from './highlights';
import * as HistoryStyles from './history';
import * as KohLanta from './koh-lanta';
import * as LegalStyles from './legal';
import * as LineUp from './line-up';
import * as LiveBar from './live-bar';
import * as MatchStyles from './match';
import * as MatchCardStyles from './match-card';
import * as MatchFilterStyles from './match-filter';
import * as Missions from './missions';
import * as Monopoly from './monopoly';
import * as MultiviewStyles from './multiview';
import * as MyMatchStyles from './mymatch';
import * as NavBarStyles from './navbar';
import * as NumericKeyboardStyles from './numeric-keyboard';
import * as Odd from './odd';
import * as RegisterModal from './register-modal';
import * as RegulationStyles from './regulation';
import * as ScoreboardsStyles from './scoreboards';
import * as Shared from './shared';
import * as SportsMenuStyles from './sports-menu';
import * as TabBarStyles from './tabbar';
import * as TopMyMatch from './topmymatch';

const theme = {
  ...BasketStyles,
  ...BurgerStyles,
  ...CommonStyles,
  ...FilterStyles,
  ...HighlightsStyles,
  ...HistoryStyles,
  ...LegalStyles,
  ...MatchStyles,
  ...MatchCardStyles,
  ...MatchFilterStyles,
  ...Monopoly,
  ...MultiviewStyles,
  ...NavBarStyles,
  ...ScoreboardsStyles,
  ...SportsMenuStyles,
  ...TabBarStyles,
  ...NumericKeyboardStyles,
  ...MyMatchStyles,
  ...LiveBar,
  ...Odd,
  ...RegisterModal,
  ...Cgu,
  ...TopMyMatch,
  ...DesktopNavigationBarStyles,
  ...KohLanta,
  ...Missions,
  ...Shared,
  ...LineUp,
  ...Countdown,
  ...RegulationStyles,
};

export default theme;
